import SEOMeta from '../../components/SEOMeta';
import { useParams } from 'react-router-dom';

const FONT = "'DM Sans', sans-serif";
const FONT_DISPLAY = "'Source Serif 4', 'DM Sans', serif";

export default function CheckoutSucessoPage() {
  const { slug } = useParams<{ slug: string }>();
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--cream)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <SEOMeta
        title="Pagamento confirmado — Inspira Músicas"
        description="Seu pagamento foi confirmado"
        path={`/ouvir-musica/${slug}/sucesso`}
        noIndex
      />

      {/* Background atmosférico */}
      <div
        aria-hidden
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 0,
          pointerEvents: 'none',
          background:
            'radial-gradient(ellipse 800px 600px at 50% -10%, rgba(255,145,77,0.18), transparent 60%), radial-gradient(ellipse 700px 500px at -10% 110%, rgba(255,176,122,0.10), transparent 60%)',
        }}
      />

      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 28,
          textAlign: 'center',
          fontFamily: FONT,
          position: 'relative',
          zIndex: 1,
        }}
      >
        {/* Check ilustrado */}
        <div style={{ marginBottom: 28, position: 'relative' }}>
          <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <radialGradient id="goldGlow" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="rgba(255,145,77,0.40)" />
                <stop offset="100%" stopColor="rgba(255,145,77,0)" />
              </radialGradient>
            </defs>
            <circle cx="60" cy="60" r="58" fill="url(#goldGlow)" />
            <circle cx="60" cy="60" r="46" fill="var(--gold-pale)" stroke="var(--gold)" strokeWidth="2" />
            <path
              d="M38 62L52 76L82 42"
              stroke="var(--gold)"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{
                strokeDasharray: 80,
                strokeDashoffset: 80,
                animation: 'inspiraDraw 0.8s 0.2s ease-out forwards',
              }}
            />
          </svg>
        </div>

        {/* Subtítulo curtinho */}
        <div
          style={{
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            color: 'var(--gold)',
            marginBottom: 12,
          }}
        >
          Está confirmado
        </div>

        {/* Título emocional */}
        <h1
          style={{
            margin: 0,
            fontSize: 'clamp(34px, 7vw, 48px)',
            fontWeight: 800,
            letterSpacing: '-0.035em',
            color: 'var(--heading-ink)',
            lineHeight: 1.05,
            maxWidth: 540,
          }}
        >
          Agora vamos compor as
          <br />
          <span style={{ fontFamily: FONT_DISPLAY, fontStyle: 'italic', fontWeight: 700, color: 'var(--gold)' }}>
            últimas notas
          </span>
        </h1>

        {/* Subtexto */}
        <p
          style={{
            fontSize: 16,
            color: 'var(--text-body)',
            marginTop: 18,
            maxWidth: 420,
            lineHeight: 1.55,
          }}
        >
          A versão completa de 3 minutos vai chegar no seu WhatsApp em até <strong>30 minutos</strong>. Aproveite — em breve você vai poder ouvir a história inteira.
        </p>

        {/* Lista de status sutil */}
        <div
          style={{
            marginTop: 28,
            padding: '18px 22px',
            background: 'var(--surface-white)',
            border: '1px solid var(--border-soft)',
            borderRadius: 18,
            maxWidth: 380,
            width: '100%',
            textAlign: 'left',
            boxShadow: '0 6px 24px rgba(0,0,0,0.04)',
          }}
        >
          <Step done text="Pagamento confirmado" />
          <Step active text="Nossos compositores estão finalizando" />
          <Step text="Você recebe no WhatsApp" />
        </div>

        {/* CTA */}
        <a
          href="https://wa.me/5511926797492"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            padding: '15px 28px',
            borderRadius: 999,
            background: 'var(--gold)',
            color: '#fff',
            fontWeight: 700,
            textDecoration: 'none',
            fontSize: 15,
            marginTop: 28,
            boxShadow: '0 8px 28px rgba(255,145,77,0.40)',
            letterSpacing: '-0.005em',
          }}
        >
          Voltar pro WhatsApp
        </a>
      </div>

      <style>{`
        @keyframes inspiraDraw {
          to { stroke-dashoffset: 0; }
        }
      `}</style>
    </div>
  );
}

function Step({ done, active, text }: { done?: boolean; active?: boolean; text: string }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '6px 0' }}>
      <div
        style={{
          width: 18,
          height: 18,
          borderRadius: '50%',
          flexShrink: 0,
          background: done ? 'var(--gold)' : active ? 'var(--gold-pale)' : 'var(--border-fade)',
          border: active ? '2px solid var(--gold)' : 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          animation: active ? 'inspiraStepPulse 1.6s ease-in-out infinite' : 'none',
        }}
      >
        {done && (
          <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
            <path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
      </div>
      <span
        style={{
          fontSize: 14,
          color: done ? 'var(--text-strong)' : active ? 'var(--text-body)' : 'var(--text-muted)',
          fontWeight: done ? 600 : active ? 600 : 500,
          textDecoration: done ? 'line-through' : 'none',
          textDecorationColor: 'var(--text-soft)',
        }}
      >
        {text}
      </span>
      <style>{`@keyframes inspiraStepPulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.12); } }`}</style>
    </div>
  );
}
